/*
 * @Author: Sam
 * @Date: 2020-11-20 10:45:17
 * @LastEditTime: 2021-04-12 14:53:26
 * @LastEditors: Connor
 * @Description: 
 * @FilePath: \thework\tofba-client\src\api\public.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
// /customer/importer/initData

import request from '@/utils/request'

// 获取站内信列表
export function manageMessage (data) {
  return request({
    url: '/message/mail/manageMessage',
    method: 'post',
    data,
  })
}
//批量更新消息状态
export function batchReadMessage (data) {
  return request({
    url: '/message/mail/batchReadMessage',
    method: 'post',
    data,
  })
}
//统计未读站内信
export function initCountFromCustomer (data) {
  return request({
    url: '/message/mail/initCountFromCustomer',
    method: 'post',
    data,
  })
}
